/**
 * Route path segments, used when defining routes (e.g. app.routes.ts children).
 * These are relative, without a leading slash.
 */
export const ROUTE_SEGMENTS = {
  HOME: '',
  QURAN: 'quran',
  DUAS_AZKAR: 'duas-azkar',
  AMAAL_PLANNER: 'amaal-planner',
  QIBLA_FINDER: 'qibla-finder',
  HISTORY: 'history',
  MASJIDS: 'masjids',
  NAMES_OF_ALLAH: 'names-of-allah',
  PRAYER_TIMES: 'prayer-times',
  ADMIN: 'admin',
  DASHBOARD: 'dashboard',
  ISLAMIC_CALENDAR: 'islamic-calendar',
  ISLAMIC_LIBRARY: 'islamic-library',
  KAZA_TRACKER: 'kaza-tracker',
  TASBEEH_COUNTER: 'tasbeeh-counter',
  KIDS_MODE: 'kids-mode',
  SETTINGS: 'settings',
  MORE: 'more',
  AUTH: 'auth',
  LOGIN: 'login',
  REGISTER: 'register',
  FORGOT_PASSWORD: 'forgot-password',
  ACCESS_DENIED: 'access-denied'
} as const;

/**
 * Fully-qualified, absolute paths for use in routerLink bindings and redirects.
 */
export const ROUTES = {
  HOME: `/${ROUTE_SEGMENTS.HOME}`,
  QURAN: `/${ROUTE_SEGMENTS.QURAN}`,
  DUAS_AZKAR: `/${ROUTE_SEGMENTS.DUAS_AZKAR}`,
  AMAAL_PLANNER: `/${ROUTE_SEGMENTS.AMAAL_PLANNER}`,
  QIBLA_FINDER: `/${ROUTE_SEGMENTS.QIBLA_FINDER}`,
  HISTORY: `/${ROUTE_SEGMENTS.HISTORY}`,
  MASJIDS: `/${ROUTE_SEGMENTS.MASJIDS}`,
  NAMES_OF_ALLAH: `/${ROUTE_SEGMENTS.NAMES_OF_ALLAH}`,
  PRAYER_TIMES: `/${ROUTE_SEGMENTS.PRAYER_TIMES}`,
  MORE: `/${ROUTE_SEGMENTS.MORE}`,

  ADMIN: `/${ROUTE_SEGMENTS.ADMIN}`,

  DASHBOARD: `/${ROUTE_SEGMENTS.DASHBOARD}`,
  DASHBOARD_QURAN: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.QURAN}`,
  DASHBOARD_DUAS_AZKAR: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.DUAS_AZKAR}`,
  DASHBOARD_AMAAL_PLANNER: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.AMAAL_PLANNER}`,
  DASHBOARD_QIBLA_FINDER: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.QIBLA_FINDER}`,
  DASHBOARD_HISTORY: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.HISTORY}`,
  DASHBOARD_MASJIDS: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.MASJIDS}`,
  DASHBOARD_NAMES_OF_ALLAH: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.NAMES_OF_ALLAH}`,
  DASHBOARD_PRAYER_TIMES: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.PRAYER_TIMES}`,
  DASHBOARD_ISLAMIC_CALENDAR: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.ISLAMIC_CALENDAR}`,
  DASHBOARD_ISLAMIC_LIBRARY: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.ISLAMIC_LIBRARY}`,
  DASHBOARD_KAZA_TRACKER: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.KAZA_TRACKER}`,
  DASHBOARD_TASBEEH_COUNTER: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.TASBEEH_COUNTER}`,
  DASHBOARD_KIDS_MODE: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.KIDS_MODE}`,
  DASHBOARD_SETTINGS: `/${ROUTE_SEGMENTS.DASHBOARD}/${ROUTE_SEGMENTS.SETTINGS}`,

  AUTH: {
    LOGIN: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.LOGIN}`,
    REGISTER: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.REGISTER}`,
    FORGOT_PASSWORD: `/${ROUTE_SEGMENTS.AUTH}/${ROUTE_SEGMENTS.FORGOT_PASSWORD}`
  },

  ACCESS_DENIED: `/${ROUTE_SEGMENTS.ACCESS_DENIED}`
} as const;
